import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Layout from "@components/layout/Layout";
import ReplaceMeterWorkflow from "@components/form/meter/replace/ReplaceMeterWorkflow";
import { useGetLevel1Resource } from "@hooks/query/useGetLevel1Resource";

const ReplaceMeter = () => {
  const { t } = useTranslation();
  const { id: level1ResourceId = "" } = useParams();
  const { data: level1Resource = {} } = useGetLevel1Resource(level1ResourceId, {
    enabled: Boolean(level1ResourceId),
  });

  return (
    <Layout
      permissions={[
        "UpdateExtractionPoint",
        "UpdateMeters",
        "CreateDeclarations",
      ]}
      breadcrumb={[
        {
          label: t("dashboard.dashboard"),
          href: "/polestar",
        },
        {
          label: level1Resource?.name,
          href: `/polestar/level1wrs/${level1ResourceId}`,
        },
        {
          label: t("level1wrs.extraction_points"),
          href: `/polestar/level1wrs/${level1ResourceId}#5`,
        },
        {
          label: t("meter.replacement.title"),
        },
      ]}
      title={t("meter.replacement.title")}
      accountingPeriodLevel1ResourceId={level1ResourceId}
    >
      <ReplaceMeterWorkflow />
    </Layout>
  );
};

export default ReplaceMeter;
